module.exports = __webpack_public_path__ + "img/708.2596fb83.jpg";